import { render, staticRenderFns } from "./TablePerimeterSecurity.vue?vue&type=template&id=60fef3cf"
import script from "./TablePerimeterSecurity.vue?vue&type=script&lang=js"
export * from "./TablePerimeterSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports